import { createStore } from '@bilibili/rxstore'

import { Draft, enableAllPlugins, produce } from 'immer'
enableAllPlugins()

export interface State {
  scene: number;
  slide: number;
  animationlock: boolean;
}

const store = createStore<State>({
  scene: 0,
  slide: 0,
  animationlock: false,
})

;(window as any).__store__ = store

type IMutationChage<T> = (draft: Draft<T>) => void;

export const mutateState = (fn: IMutationChage<State>) =>
  store.next(s => produce(s, fn))

export default store
